export default "__VITE_ASSET__DLqXrzcf__"